<script lang="ts">
    export let checked = false;
    export let value = "";
    export let group = "";
    export let required = true;
    export let name = "";
    export let otherInput = false;

    $: disabled = value != group;
</script>

<main>
    <label>
        <input
            type="radio"
            bind:group
            {checked}
            class="mb-3"
            {value}
            {required}
            {name}
        />
        {#if otherInput}
            <input
                {disabled}
                type="text"
                {value}
                on:input={(event) => {
                    if (event.currentTarget instanceof HTMLInputElement)
                        value = group = event.currentTarget.value;
                }}
                required
            />
        {:else}
            {value}
        {/if}
    </label>
</main>

<style>
    main {
        display: block;
    }
</style>
